var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._l((_vm.widgets),function(widget){return [_c(_vm.type(widget),{tag:"component",attrs:{"configuration":widget}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }